export default {

    GET_USER_DATA_REQUEST: 'GET_USER_DATA_REQUEST',
    GET_USER_DATA_SUCCESS: 'GET_USER_DATA_SUCCESS',
    GET_USER_DATA_FAIL: 'GET_USER_DATA_FAIL',

    SET_USER_IS_LOADING: 'SET_USER_IS_LOADING'
};
